import * as api from "../api";
import { FUResourceManager } from "../packages/sdk/fu_resource_manager";
import FURenderKitSDK from "../packages/sdk/fu_render_kit"
import Socket from "@/packages/sdk/socket";

export const CONFIG = {
    appid: process.env.REACT_APP_ID,
    socketUrl: "wss://websocket-api.faceunity.com",
    appversion: process.env.REACT_APP_VERSION,
    sdkversion: process.env.REACT_APP_SDK_VERSION,
};

export const RESOURCE_MANAGER = new FUResourceManager({
    appId: CONFIG.appid,
    appversion: CONFIG.appversion,
    sdkversion: CONFIG.sdkversion,
    cacheLimit: 10,
    api,
    preferIDBFS: !window.location.search.includes("disable_cache"),
    maxHistoryLength: 10,
});

export const RENDER_SDK = new FURenderKitSDK({
    resourceManager: RESOURCE_MANAGER
})

export const SOCKET_INS = new Socket(
    CONFIG.socketUrl,
)
